export default __webpack_public_path__ + "pgnv-assets/289f78534d4b080898404cd161d23b26.png";